// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1cf4t","label":"Radio_label__WFGqS","checkMark":"Radio_checkMark__2-Rs1","disabled":"Radio_disabled__2QV3v"};